export enum PositionAction {
  LIST,
  INFO,
  ADD_LIQUIDITY,
  DEL_LIQUIDITY,
  MINT_POSITION,
}

export enum TOKEN {
  _0,
  _1,
}

export enum VIEW_SIDE {
  NONE,
  A_TO_B,
  B_TO_A,
}
